import ISupplierModel from "../models/ISupplierModel";

// Industry names eligible for NYSLA: Wine, Beer, Spirits
const NYSLA_INDUSTRY_NAMES = ["wine", "beer", "spirits"];

const WineService = {
    /**
     * Check if supplier is in the Wine industry
     */
    isWineIndustrySupplier: (supplierModel: ISupplierModel): boolean => {
        return supplierModel.Industries?.some((industry) => industry.name.toLowerCase() === "wine") ?? false;
    },

    /**
     * Check if supplier is eligible for NYSLA (Wine, Beer, or Spirits industry)
     */
    isNYSLAEligibleSupplier: (supplierModel: ISupplierModel): boolean => {
        return supplierModel.Industries?.some((industry) => NYSLA_INDUSTRY_NAMES.includes(industry.name.toLowerCase())) ?? false;
    },
};

export default WineService;
